import { createAsyncThunk } from "@reduxjs/toolkit";
import requestUtil from "../../helpers/requestUtil";

const getLocationList = async ({url}, thunkAPI) => {
  const state = thunkAPI.getState();
  const locationDashboardSharedList = state.shared.locationDashboardSharedList;
  if(locationDashboardSharedList?.length > 0){
    return locationDashboardSharedList;
  }
  try {
    const data = await requestUtil(url, "GET");
    return data
  } catch (error) {
    thunkAPI.rejectWithValue(error);
  }
};

export const getLocationListThunk = createAsyncThunk(
    "shared/getLocationList",
    getLocationList
)
